<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      :before-query-search="beforeQuerySearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
          <el-col :span="colSpan">
            <BjFormItemCode v-model="queryParams.code" :placeholder="$t('BusinessPurchaseOrder2.code')" @keyup.enter.native="handleQuery" />
          </el-col>
          <!-- <el-col :span="colSpan">
            <BjFormItemCode v-model="queryParams.thirdCode" :placeholder="$t('BusinessPurchaseOrder2.externalPo')" />
          </el-col> -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseEntryComView.statusMeaning')" prop="status">
              <BjSelectLov v-model="statusList" :placeholder="$t('BusinessPurchaseEntryComView.statusMeaning')" multiple :option-list="statusOptionList" />
            </el-form-item>
          </el-col>
          <el-col v-if="!$store.getters.cusId" :span="colSpan">
            <el-form-item :label="$t('BusinessAfterCsgReturn.table.cusName')">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" @change="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrder2.Unit')" prop="shippingMethod">
              <BjSelectLov v-model="queryParams.shippingMethod" :placeholder="$t('BusinessPurchaseOrder2.Unit')" :option-list="SHIPPING_METHODS" @change="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessBatchInventoryQuery.table.skuCode')" prop="skuCode">
              <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessBatchInventoryQuery.table.skuCode')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col v-if="isOpen" :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrder2.dialog.arriveDate')">
              <BjDateTimerPicker v-model="queryParams.deliveryTimeEnd" :tip-show="false" :placeholder="$t('BusinessPurchaseOrder2.dialog.arriveDate')" />
            </el-form-item>
          </el-col>
          <el-col v-if="!isOpen" :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseOrderDetail.finishTime')">
              <BjDateRangePicker v-model="queryParamsTime_finish" :placeholder="$t('BusinessPurchaseOrderDetail.finishTime')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <BjFormItemCode v-model="queryParams.containerId" :placeholder="$t('BusinessPurchaseOrder2.container')" @keyup.enter.native="handleQuery" />
          </el-col>
      </template>
      <!-- <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <BjStatusTabs
            :value="tabsValue"
            :option-list="TAB_LIST"
            @handleTabClick="handleTabClick"
          />
        </el-col>
      </template> -->
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:BusinessPurchaseOrderCsgAdd type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
          <BjFrontendExport
            :disabled="!selectedRows.length"
            type="primary"
            :label-list="exportLabelList"
            :rows="selectedRows"
            :file-name="exportFileName"
            worksheet="worksheet1"
            @export-success="resetAfterExport"
          />
          <el-button v-if="isOpen" v-permission:BusinessPurchaseOrderDelete type="primary" @click="onDeleteSelected">{{ $t('delText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="false" />
              <template v-else-if="col.prop === 'code'">
                <span class="link" @click="onDetail(row)">{{ row[col.prop] }}</span>
                <BjCopyIcon :copy="row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'thirdCode'">
                <span>{{ row.shippingMethod == 'Container' ? row.containerId : row.thirdCode }}</span>
              </template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-button v-permission:BusinessPurchaseOrderCsgAdminDetail type="text" class="view-btn" @click="onDetail(row)">{{ $t('BusinessPurchaseOrderList.View') }}</el-button>
              <el-button v-if="row.status === 'New'" v-permission:BusinessPurchaseOrderCsgAdminDetail type="text" class="delete-btn" @click="onEdit(row)">{{ $t('editText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
import { STORAGE_ORDER_STATUS_LIST, STORAGE_ORDER_STATUS_LIST2 } from '@/utils/constants';
import moment from 'moment';

export default {
  name: 'BusinessPurchaseOrderCsgIndex',
  mixins: [pageMiXin],
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      colSpan: 6,
      queryApi: purchaseApi.getCsgPurchaseOrderList,
      // 查询参数
      queryParamsTime_finish: null,
      queryParams: {
        code: null,
        skuCode: null,
        containerId: null,
        status: this.isOpen ? ['New', 'Uploaded', 'Arrived', 'Receiving', 'Received', 'In Progress', 'UploadFail'] : ['Cancelled', 'Done'],
        finishTimeBegin: null,
        finishTimeEnd: null,
        thirdCode: null,
        deliveryTimeEnd: null,
      },
      TAB_LIST: [
      {
          label: 'Open PO',
          value: 'open'
        },
        {
          label: 'Closed PO',
          value: 'close'
        }
      ],
      tabsValue: 'open',
      labelsVersion: 0,
      labelList1: [
        { label: this.$t('BusinessPurchaseOrder2.code'), prop: 'code', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('BusinessPurchaseOrder2.Unit'), prop: 'shippingMethod', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('BusinessPurchaseOrder2.container'), prop: 'thirdCode', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('goodsBrand.page.Status'), prop: 'status', isCheck: true, disabled: false},
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.receiveDate'), prop: 'receiveDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.arrivedAt'), prop: 'deliveryTime', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.ConEmpDate'), prop: 'containerReadyTime', isCheck: true, disabled: false},
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 140 },
      ],
      labelList2: [
        { label: this.$t('BusinessPurchaseOrder2.code'), prop: 'code', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('BusinessPurchaseOrder2.Unit'), prop: 'shippingMethod', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('BusinessPurchaseOrder2.container'), prop: 'thirdCode', isCheck: true, disabled: false, width: 140 },
        { label: this.$t('goodsBrand.page.Status'), prop: 'status', isCheck: true, disabled: false},
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.receiveDate'), prop: 'receiveDate', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.arrivedAt'), prop: 'deliveryTime', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.ConEmpDate'), prop: 'containerReadyTime', isCheck: true, disabled: false},
        { label: this.$t('BusinessPurchaseOrder2.ConCollDate'), prop: 'containerEndTime', isCheck: true, disabled: false},
        { label: this.$t('RefundOnlyToBeReviewed.form.Completion'), prop: 'finishTime', isCheck: true, disabled: false},
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 140 },
      ],
      statusList: [],
      SHIPPING_METHODS: [
        {value: 'Container', label: 'Container'},
        {value: 'Pallet', label: 'Pallet'},
        {value: 'Carton', label: 'Carton'},
      ],
    };
  },
  computed: {
    labelList() {
      return this.isOpen ? this.labelList1 : this.labelList2;
    },
    statusOptionList() {
      return this.isOpen ? STORAGE_ORDER_STATUS_LIST : STORAGE_ORDER_STATUS_LIST2;
    },
    exportLabelList() {
      const dateProps = ['creationDate', 'receiveDate', 'deliveryTime', 'containerReadyTime', 'containerEndTime', 'finishTime'];
      return this.labelList.map(column => {
        if (column.prop === 'thirdCode') {
          return { ...column, export: { formatter: (value, row) => row.shippingMethod == 'Container' ? row.containerId : row.thirdCode } };
        }
        return dateProps.includes(column.prop)
          ? { ...column, export: { dateFormat: 'DD/MM/YYYY HH:mm' } }
          : column;
      });
    },
    exportFileName() {
      return `inbound receipt ${moment().format('DD_MM_YYYY HH:mm')}.xls`;
    },
  },
  watch: {
    queryParamsTime_finish(v) {
      this.queryParams.finishTimeBegin = (v || [])[0];
      this.queryParams.finishTimeEnd = (v || [])[1];
    },
    statusList(val) {
      if (val.length > 0) {
        this.queryParams.status = val;
      } else {
        this.queryParams.status = this.isOpen ? ['New', 'Uploaded', 'Arrived', 'Receiving', 'Received', 'In Progress', 'UploadFail'] : ['Cancelled', 'Done'];
      }
    }
  },
  mounted() {},
  methods: {
    handleTabClick(tab) {
      this.tabsValue = tab.name;
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_finish = null;
      this.queryParamsTime_expected = null;
      this.queryParams.code = null;
      this.queryParams.containerId = null;
      this.queryParams.thirdCode = null;
      this.queryParams.deliveryTimeEnd = null;
      this.statusList = [];
      this.queryParams.status = this.isOpen ? ['New', 'Uploaded', 'Arrived', 'Receiving', 'Received', 'In Progress', 'UploadFail'] : ['Cancelled', 'Done'];
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 新增 */
    onAdd() {
      this.$router.push({
        name: 'BusinessPurchaseOrderCsgAdd',
      });
    },
    /** 修改 */
    onEdit(row) {
      const { id } = row;
      this.$toPage('BusinessPurchaseOrderCsgAdminEdit', {
        id,
      });
    },
    resetAfterExport() {
      this.$refs.BjPage.onResetQuery();
    },
    /** 删除 */
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      const result = this.selectedRows.some(item => item.status !== 'New');
      if (result) return this.$message.warning(this.$t('BusinessPurchaseOrder2.hintMsg'));
      const ids = this.selectedRows.map(e => {
        return { id: e.id, objectVersionNumber: e.objectVersionNumber };
      });
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
      }).then(() => {
        this.batchDeleteApi(ids);
      });
    },
    onDetail(row) {
      this.$toPage('BusinessPurchaseOrderCsgAdminDetail', {
        id: row.id,
        code: row.code
      });
    },
    batchDeleteApi(ids) {
      purchaseApi.delCsgPurchaseOrder({ ids }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    beforeQuerySearch(conditionObj) {
      const obj = {
        ...conditionObj
      };
      delete obj.currentPage;
      delete obj.pageSize;
      delete obj.total;
      return new Promise(resolve => {
        resolve(obj);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
